import { FC, memo } from 'react';

import './styles.scss';

const SplashScreen: FC = () => {
  return (
    <div className="clik-inventory__splash-screen">
      <div className="center">
        <div className="logo">
          <i className="icon-logo_clik_60x68">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
        <div className="spinner-wrapper">
          <div className="spinner">
            <div className="inner">
              <div className="gap" />
              <div className="left">
                <div className="half-circle" />
              </div>
              <div className="right">
                <div className="half-circle" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(SplashScreen);
